function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment } from 'react';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { formatShortPrice } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
var housesIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-nearby-sales/static/nearby-sales-houses-icon_1519d849.svg";
import styleFactory from './signed-in.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SignedIn = _ref => {
  var layout = _ref.layout,
    nearbySales = _ref.nearbySales,
    soldDuration = _ref.soldDuration,
    propertyType = _ref.propertyType;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref2 = nearbySales || {},
    count = _ref2.count,
    bedrooms = _ref2.bedrooms,
    searchRadius = _ref2.searchRadius,
    searchUrl = _ref2.searchUrl,
    priceLow = _ref2.priceLow,
    priceMedian = _ref2.priceMedian,
    priceHigh = _ref2.priceHigh;
  var styles = styleFactory(layout);
  var handleClick = () => {
    sendEvent('nearby-sales-click');
  };
  var _map = [priceLow || 0, priceMedian || 0, priceHigh || 0].map(formatShortPrice),
    _map2 = _slicedToArray(_map, 3),
    formattedPriceLow = _map2[0],
    formattedPriceMedian = _map2[1],
    formattedPriceHigh = _map2[2];
  return ___EmotionJSX("div", {
    css: styles.nearbySales
  }, ___EmotionJSX("div", {
    css: styles.body
  }, ___EmotionJSX("div", {
    css: styles.summary
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, ___EmotionJSX("strong", null, count), " ", propertyType, " sold"), ___EmotionJSX("div", {
    css: styles.detail
  }, ___EmotionJSX("strong", null, bedrooms, " bed"), " within", ' ', ___EmotionJSX("strong", null, searchRadius, "km"), soldDuration && ___EmotionJSX(Fragment, null, ' ', "in the last ", ___EmotionJSX("strong", null, soldDuration)))), ___EmotionJSX(Separator, {
    css: styles.bodySeparator
  }), ___EmotionJSX("div", {
    css: styles.prices
  }, ___EmotionJSX("dl", {
    css: styles.stat
  }, ___EmotionJSX("dt", {
    css: styles.statName
  }, "Low"), ___EmotionJSX("dd", {
    css: styles.statValue
  }, formattedPriceLow.price, ___EmotionJSX("span", {
    css: styles.unit
  }, formattedPriceLow.unit))), ___EmotionJSX("dl", {
    css: styles.stat
  }, ___EmotionJSX("dt", {
    css: styles.statName
  }, "Median"), ___EmotionJSX("dd", {
    css: styles.medianValue
  }, formattedPriceMedian.price, ___EmotionJSX("span", {
    css: styles.unit
  }, formattedPriceMedian.unit))), ___EmotionJSX("dl", {
    css: styles.stat
  }, ___EmotionJSX("dt", {
    css: styles.statName
  }, "High"), ___EmotionJSX("dd", {
    css: styles.statValue
  }, formattedPriceHigh.price, ___EmotionJSX("span", {
    css: styles.unit
  }, formattedPriceHigh.unit))))), ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX("a", {
    href: searchUrl,
    onClick: handleClick,
    css: styles.link,
    target: "_blank",
    rel: "noreferrer"
  }, ___EmotionJSX("div", null, ___EmotionJSX("img", {
    css: styles.linkIcon,
    alt: "",
    src: housesIcon
  }), ___EmotionJSX("span", {
    css: styles.linkText
  }, "View properties")), ___EmotionJSX("div", null, ___EmotionJSX(ChevronRightIcon, {
    css: styles.linkIcon
  }))));
};
export default SignedIn;